import WRAP from "WRAP-JS";

/* eslint-disable */
WRAP.Renderer.LightningExt = function() {
    WRAP.Renderer.call(this);
    
    this.draw = function(layer, content, conf, context, style, data, revision, dl) {
        WRAP.Geo.check(content, context, style, dl);
        
        var dh = data;
        var data_conf = dh.source.data.conf;
        var tiled = data_conf&&data_conf.separation;

        var valid = true;
        if ( tiled && this.context_revision != revision.context ) {
            valid = false;
        }
        if ( this.conf_revision != revision.conf ) {
            valid = false;
        }
        if ( this.data_revision != revision.data ) {
            valid = false;
        }
        if ( this.content_revision != revision.content ) {
            valid = false;
        }
        if ( valid )
            return;
        
        layer.setStatus({status:"invalid", reason:"data load waiting."});

        var asynchronous_draw = conf.Attributes.asynchronous_draw;

        var bounds = [];
        if ( !tiled ) {
            bounds.push({north:80, south:-80, west:0, east:360});
        }
        else {
            for ( var i = 0 ; i < context.tiles.length ; i++ ) {
                var tb = context.tiles[i].bounds;
                var b = {
                    north:tb.north/60,
                    south:tb.south/60,
                    west:tb.west/60,
                    east:tb.east/60
                }
                bounds.push(b)
            }
        }
        var tiles = this.getGeoObject(data, "data", bounds, content, null, layer, asynchronous_draw);
        if ( !tiles )
            return;

        var style = conf.Attributes.style.default;
        var icon_width = style.icon_width;
        var icon_height = style.icon_height;
        var icon_offset_x = style.icon_offset_x;
        var icon_offset_y = style.icon_offset_y;
        var icon = [].concat(style.icon);

        icon.sort(function(a,b) { if (a.ge>b.ge) return -1; if (a.ge<b.ge) return 1; return 0;});

        if ( !Array.isArray(tiles) )
            tiles = [tiles];

        var loaded = [];
        for ( var i = 0 ; i < tiles.length ; i++ ) {
            if ( tiles[i] )
                loaded.push(tiles[i]);
        }
        if ( !asynchronous_draw && loaded.length != tiles.length )
            return;
        //console.log("loaded="+loaded.length+" / tiles="+tiles.length)        
        
        layer.clear();
        
        var merged = [];
        for ( var i = 0 ; i < loaded.length ; i++ ) {
            var t = loaded[i];
            if ( t.type == "Feature" ) {
                merged.push(t);
            }
            else {
                merged = merged.concat(t.features);
            }
        }

        //filter features
        var features = [];
        for ( var i = 0 ; i < merged.length ; i++ ) {
            var t = merged[i];
            if ( conf.Attributes.filter && !conf.Attributes.filter(t, i, merged) )
                continue;
            features.push(t);
        }
        
        //sort features
        features.sort((a, b) => {
            if (a.properties.obs_time > b.properties.obs_time) return -1;
            if (a.properties.obs_time < b.properties.obs_time) return 1;
            if (a.properties.THNDR_TYPE > b.properties.THNDR_TYPE) return -1;
            if (a.properties.THNDR_TYPE < b.properties.THNDR_TYPE) return 1;
            return 0;
        });

        var reftime = new WRAP.Core.DateTime(content&&content.custom_time);

        for ( var j = 0 ; j < icon.length ; j++ ) {
            var length = features && features.length;
            for ( var i = length - 1 ; i >= 0 ; i-- ) {
                var item = features[i];
                if ( !item )
                    continue;
                var geometry = item.geometry;
                if ( !geometry )
                    continue;
                if ( geometry.type == "Point" ) {
                    var prop = item.properties;
                    if ( prop && prop.display_flag === false )
                        continue;

                    if ( style.property_filter ) {
                        var valid = false;
                        for ( var key in style.property_filter ) {
                            if ( prop ) {
                                style.property_filter[key].forEach(function(v){
                                    if (v==prop[key] )
                                        valid = true;
                                })
                                if ( valid )
                                    break;
                            }
                        }
                        if ( !valid )
                            continue;
                    }
                    
                    var dt = new WRAP.Core.DateTime(prop.obs_time);
                    var e = dt.diff(reftime)/60;
                    //console.log("Reftime "+reftime.text()+" dataTime="+dt.text()+" diff_min="+e);
                    var type = prop.THNDR_TYPE;
                
                    if ( parseInt(icon[j].ge) <= e && e < parseInt(icon[j].lt) ) {
                        var point = geometry.coordinates;
                        var feature = new WRAP.Geo.Feature.Image({
                            point:point,
                            image:icon[j]["image"+type] || icon[j].image,
                            width:icon_width,
                            height:icon_height,
                            offsetX:icon_offset_x,
                            offsetY:icon_offset_y,
                        });
                        feature.geo = item;
                        layer.addFeature(feature);
                        features.splice(i, 1);
                    }
                }
            }
        }
        if ( tiles.length == loaded.length ) {
            this.context_revision = revision.context;
            this.conf_revision = revision.conf;
            this.data_revision = revision.data;
            this.content_revision = revision.content;
            if ( layer.getStatus().status != 'error' )
                layer.setStatus({status:"valid"});
        }
        WRAP.Geo.invalidate();
    }
}
/* eslint-enable */